import React from "react";

const inputBaseClass =
  "w-full border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white text-gray-700";

/**
 * UserProfiles filter field: label + input or select.
 * @param {string} type - 'text' | 'number' | 'date' | 'select'
 * @param {string} name - input name
 * @param {string} label - label text
 * @param {string|number} value - controlled value
 * @param {function} onChange - (e) => {}
 * @param {string} [placeholder]
 * @param {Array} [options] - for select: [{ id, name }] or [{ value, label }]
 * @param {number} [min] - for number
 * @param {number} [max] - for number
 * @param {boolean} [compact] - smaller padding (default true)
 * @param {string} [className] - extra class for wrapper
 */
const FilterField = ({
  type = "text",
  name,
  label,
  value,
  onChange,
  placeholder = "",
  options = [],
  min,
  max,
  compact = true,
  className = "",
}) => {
  const inputClass = compact
    ? `${inputBaseClass} py-1.5 px-2 text-xs md:text-sm`
    : `${inputBaseClass} p-2.5 text-sm`;
  const labelClass = "block text-xs font-semibold text-gray-700 mb-1";

  const commonInputProps = {
    name,
    value: value ?? "",
    onChange,
    className: inputClass,
    placeholder,
  };

  if (type === "select") {
    return (
      <div className={className}>
        <label className={labelClass}>{label}</label>
        <select {...commonInputProps}>
          {options.map((opt, idx) => (
            <option
              key={opt.id ?? opt.value ?? idx}
              value={String(opt.id ?? opt.value ?? "")}>
              {opt.name ?? opt.label ?? opt.value}
            </option>
          ))}
        </select>
      </div>
    );
  }

  return (
    <div className={className}>
      <label className={labelClass}>{label}</label>
      <input
        type={type}
        min={min}
        max={max}
        {...commonInputProps}
      />
    </div>
  );
};

export default FilterField;
